module.exports = new __parcel__URL__("faq_closed_btn_non_ja.f93dfbb9.webp").toString();